import { Office, ResourceType } from '@gettactic/api';
import { addMinutes } from 'date-fns';
import { convertTZ } from '../date-time/convertTZ';

/**
 * Important Note: Be careful when modifying this function. It's used for a lot of "availability" display logic.
 * It's extra confusing since the API is very literal about maximum amount of time in the future a user can reserve, to the hour
 * but administrators think in terms of number of days in the future. We use logic in components elsewhere to compensate.
 */
export function getMaxDateAllowedToReserve(
  officeTz: string,
  office: Office | undefined,
  resType: ResourceType
) {
  if (!office || !officeTz) {
    return null;
  }
  const maxMin =
    resType === 'meeting_room'
      ? office.meeting_room_reservation_period_min
      : office.workspace_reservation_period_min;
  if (maxMin === null) {
    return null;
  }
  const d = convertTZ(new Date(), officeTz);
  return addMinutes(d, maxMin);
}
